import { render, staticRenderFns } from "./DCP.vue?vue&type=template&id=a6e153ae&"
import script from "./DCP.vue?vue&type=script&lang=js&"
export * from "./DCP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports